import { Transaction } from "@/context/FinanceContext";

/**
 * Maps a Supabase transaction record to the local Transaction format.
 * Centralizes the mapping logic to avoid duplication and ensure consistency.
 */
export function mapSupabaseToLocalTransaction(record: any): Transaction {
  return {
    id: record.id,
    description: record.description,
    value: record.value,
    type: record.type,
    categoryId: record.chart_of_accounts_id || '',
    accountId: record.account_id || '',
    costCenterId: record.cost_center_id,
    paymentMethodId: record.payment_method_id,
    supplierId: record.supplier_id,
    issueDate: record.issue_date,
    dueDate: record.due_date,
    paymentDate: record.payment_date,
    settled: record.settled ?? false,
    parcelMode: record.parcel_mode,
    parcels: record.parcels,
    parcelIndex: record.parcel_index,
    issueDateMode: record.issue_date_mode,
    kind: record.kind || 'normal',
    transferGroupId: record.transfer_group_id,
    saleId: record.sale_id,
    purchaseId: record.purchase_id,
    reconciled: record.reconciled ?? false,
    reconciledAt: record.reconciled_at ?? null,
    ofxFitid: record.ofx_fitid ?? null,
    ofxImportId: record.ofx_import_id ?? null,
  };
}

/**
 * Maps an array of Supabase transaction records to local format.
 */
export function mapSupabaseTransactions(records: any[]): Transaction[] {
  return (records || []).map(mapSupabaseToLocalTransaction);
}
